<template>
  <v-flex xs12 class="pa-4">
    <span class="details-title">
      <v-btn icon text @click="$emit('displayReservation')"
        ><v-icon>mdi-arrow-left</v-icon></v-btn
      >
      {{ $t('activity_reservation.details') }}</span
    >
    <v-divider class="mb-4 mt-4" />
    <order-summary
      :orderLines="order.orderLines"
      :totalByCurrencies="totalByCurrencies"
      :currencies="currencies"
      isPaid
    />
  </v-flex>
</template>

<script>
import moment from 'moment'

import { activityReservationColorsByStatus } from '@/config'

import moneyMixins from '@/mixins/MoneyFormat'

export default {
  props: {
    item: Object,
  },
  components: {
    OrderSummary: () =>
      import('@/components/view-components/catalog/OrderSummary.vue'),
  },
  data () {
    return {
      moment,
      activityReservationColorsByStatus: activityReservationColorsByStatus,
    }
  },
  computed: {
    order () {
      return this.item.order || this.item.pendingOrder
    },
    currencies () {
      return this.item.currencies || []
    },
    totalByCurrencies () {
      if (!this.order) {
        return null
      }
      var totals = {}
      this.order.orderLines.forEach(orderLine => {
        if (!orderLine.parentOrderLine) {
          orderLine.price.forEach((price) => {
            if (totals[price.currencyId]) {
              totals[price.currencyId].amount += price.amount * orderLine.quantity
            } else {
              const currency = this.currencies.find(c => {
                return c.id === price.currencyId
              })
              totals[price.currencyId] = { amount: price.amount * orderLine.quantity, currency }
            }
          })
        }
      })
      return Object.keys(totals).map((currencyId) => {
        return totals[currencyId]
      })
    },
  },
  mixins: [moneyMixins],
}
</script>

<style lang="scss">
.details-header {
  background-size: cover;
  background-position: center center;
  height: 135px !important;
  .details-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-flex;
    color: white;
    background: rgba(black, 0.5);
  }
}
.details-title {
  color: grey;
  font-size: 24px;
}
.details-data {
  color: grey;
  font-size: 18px;
}
.details-data-bold {
  font-weight: bold;
  color: grey;
  font-size: 18px;
}
</style>
